module.exports = __webpack_public_path__ + "img/publicar.d635f5ee.png";